export const formIds = {
  CONTACT_FORM: 'V2fplTha6ZoNB167oXMo',
  FREE_PROGRAM_FORM: 'vwVqxYAPCgLlD0owwl1f',
  SUBSCRIBE_FORM: 'dkWjokoIZCOeaS4dF4eT',
  VOLUNTEER_FORM: 'px7Y0QtshEN7oJ0ZE516',

};
